import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import { isFileSizeGreaterThan } from "../../utils/file.js";
import Button from "@mui/material/Button";
import NotificationPopup from "../popup/NotificationPopup";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

export default function UploadButton({ label, onChange, disabled, inputProps, buttonProps }) {
  const [message, setMessage] = useState("");

  const isFileTypeValid = (file, acceptedFormats) => {
    return acceptedFormats.some((format) => {
      const mimeType = format.trim();
      if (mimeType === "image/*") {
        return file.type.startsWith("image/");
      }
      const extension = mimeType.startsWith(".") ? mimeType : `.${mimeType.split("/")[1]}`;
      return file.type === mimeType || file.name.toLowerCase().endsWith(extension.toLowerCase());
    });
  };

  const handleFileChange = (event) => {
    const files = event.target.files;

    if (!files || disabled) return;

    const acceptedFormats = inputProps?.accept?.split(",") || [];
    const maxSizeMB = inputProps?.maxSizeMB || null;

    const isValid = Array.from(files).every((file) => {
      const isSizeValid = maxSizeMB ? !isFileSizeGreaterThan(file.size, maxSizeMB) : true;
      const isTypeValid = acceptedFormats.length > 0 ? isFileTypeValid(file, acceptedFormats) : true;

      if (!isSizeValid) {
        setMessage(`Upload Failed: File "${file.name}" exceeds the maximum size of ${maxSizeMB}MB.`);
        return false;
      }

      if (!isTypeValid) {
        setMessage(`Upload Failed: File "${file.name}" has an unsupported format.`);
        return false;
      }

      return true;
    });

    if (isValid) {
      setMessage("");
      if (inputProps?.multiple) {
        onChange(files);
      } else {
        onChange(event);
      }
    }
  };
  return (
    <>
      <Button component="label" role={undefined} disabled={disabled} {...buttonProps}>
        {label}
        {onChange && <VisuallyHiddenInput type="file" onChange={handleFileChange} {...inputProps} />}
      </Button>
      <NotificationPopup
        open={message}
        onClose={() => setMessage("")}
        title="Warning"
        message={message}
        iconSrc="assets/icons/error.svg"
        buttonLabel="Close"
        variant="error"
      />
    </>
  );
}
